<template>
    <div class="app flex-row align-items-center" id="login-form">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-md-6">
                    <div class="card-group mb-0">
                        <div class="card p-4">
                            <div class="card-block">
                                <div id="login-logo"><img src="/static/img/logo.png"/></div>
                                <div :class="error ? 'input-group mb-3 has-danger has-feedback' : 'input-group mb-3'">
                                    <span class="input-group-addon"><i class="fa fa-key"></i></span>
                                    <input type="text"
                                           :class="error ? 'form-control form-control-danger' : 'form-control'"
                                           :placeholder='$t("auth.key")' v-model="credentials.code" required>
                                </div>
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="alert alert-danger" v-show="error">
                                            {{ error }}
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <button type="button" class="btn btn-primary px-4" @click="redirect()" v-bind:disabled="this.authLoading">{{ $t("auth.login_action") }} <i class="fa fa-spinner fa-spin" aria-hidden="true" v-show="this.authLoading"></i>
                                        </button>
                                    </div>
                                    <div class="col-md-6">
                                        <Language></Language>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import auth from './../../api/Auth.js'
  import Language from './../../i18n/Language.vue'

  export default {
    name: 'Impersonate',
    components: {
      Language
    },
    data: function () {
      return {
        credentials: {
          code: ''
        },
        error: false,
        authLoading: false,
        routese: {}
      }
    },
    mounted: function () {
      auth.logoutImpersonate()
      this.routese = this.$route.query
    },
    methods: {
      redirect () {
        if (this.routese.username && this.routese.password && this.routese.user_from) {
          auth.loginImpersonate(this)
        }
        this.error = false
        this.authLoading = true
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Impersonate.vue?0ca894fa